"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointConverter = void 0;
const Point_1 = require("../../graphics2d/Point");
const Point2D_1 = require("../../graphics2d/Point2D");
const GeoPixelConversion_1 = require("./GeoPixelConversion");
/**
 *
 *
 */
class PointConverter {
    _controlLat = 0;
    _controlLong = 0;
    _scale = 0;
    _metersPerPixel = 0;
    _normalize = true;
    set_normalize(value) {
        this._normalize = value;
    }
    constructor(...args) {
        switch (args.length) {
            case 3: {
                const [controlLong, controlLat, scale] = args;
                try {
                    this._controlLat = controlLat;
                    this._controlLong = controlLong;
                    this._scale = scale;
                    this._metersPerPixel = GeoPixelConversion_1.GeoPixelConversion.metersPerPixel(scale);
                }
                catch (e) {
                    if (e instanceof Error) {
                        throw e;
                    }
                    else {
                        throw e;
                    }
                }
                break;
            }
            case 5: {
                const [left, top, right, bottom, scale] = args;
                try {
                    this._controlLat = top;
                    this._controlLong = left;
                    this._scale = scale;
                    this._metersPerPixel = GeoPixelConversion_1.GeoPixelConversion.metersPerPixel(scale);
                    if (top < bottom) {
                        this._metersPerPixel = -this._metersPerPixel;
                    }
                }
                catch (e) {
                    if (e instanceof Error) {
                        throw e;
                    }
                    else {
                        throw e;
                    }
                }
                break;
            }
            default: {
                throw Error(`Invalid number of arguments`);
            }
        }
    }
    PixelsToGeo(...args) {
        const [pixel] = args;
        try {
            let y = GeoPixelConversion_1.GeoPixelConversion.y2lat(pixel.getY(), this._scale, this._controlLat, this._metersPerPixel);
            let x = GeoPixelConversion_1.GeoPixelConversion.x2long(pixel.getX(), this._scale, this._controlLong, y, this._metersPerPixel);
            if (pixel instanceof Point_1.Point)
                return new Point_1.Point(x, y);
            else
                return new Point2D_1.Point2D(x, y);
        }
        catch (e) {
            if (e instanceof Error) {
                throw e;
            }
            else {
                throw e;
            }
        }
    }
    GeoToPixels(...args) {
        const [coord] = args;
        try {
            let y = GeoPixelConversion_1.GeoPixelConversion.lat2y(coord.getY(), this._scale, this._controlLat, this._metersPerPixel);
            let x = GeoPixelConversion_1.GeoPixelConversion.long2x(coord.getX(), this._scale, this._controlLong, coord.getY(), this._metersPerPixel, this._normalize);
            if (coord instanceof Point_1.Point)
                return new Point_1.Point(x, y);
            else
                return new Point2D_1.Point2D(x, y);
        }
        catch (e) {
            if (e instanceof Error) {
                throw e;
            }
            else {
                throw e;
            }
        }
    }
}
exports.PointConverter = PointConverter;
//# sourceMappingURL=PointConverter.js.map